<template>
  <div class="MPRDicomView">
    <div class="MPR-loading" v-if="loading">
      <h3>Loading...</h3>
    </div>
    <div class="MPR-cont" v-else>
      <div class="MPR-cont-header">
        <button
          @click="selectTool('LEVEL')"
          :class="{ active: activeTool === 'LEVEL' }"
        >
          <img src="https://img.icons8.com/material-rounded/344/contrast.png" />
          Level
        </button>
        <button
          @click="selectTool('SELECT')"
          :class="{ active: activeTool === 'SELECT' }"
        >
          <img src="https://img.icons8.com/material/344/define-location.png" />
          Select
        </button>
        <button
          @click="checkBox"
          :class="{ active: checkBoxTool === 'CHECKBOX' }"
        >
          <img src="https://img.icons8.com/material/344/define-location.png" />
          Sync Window Leveling
        </button>
        <!-- <span>
          <input type="checkbox" id="checkbox" v-model="syncWindowLevels" />
          <label for="checkbox">Sync Window Leveling</label>
        </span> -->
        <!-- <p>Intersect point: {{ sliceIntersection }}</p> -->
      </div>
      <div class="MPR-cont-cont row">
        <div class="col" v-for="(view, key) in viewData" :key="key">
          <table class="MPR-table">
            <tr>
              <td>模式</td>
              <td>
                <input
                  type="radio"
                  :id="`${key}1blend`"
                  value="none"
                  v-model="view.blendMode"
                />
                <label :for="`${key}1blend`">None</label>

                <input
                  type="radio"
                  :id="`${key}2blend`"
                  value="MIP"
                  v-model="view.blendMode"
                />
                <label :for="`${key}2blend`">MIP</label>

                <input
                  type="radio"
                  :id="`${key}3blend`"
                  value="MINIP"
                  v-model="view.blendMode"
                />
                <label :for="`${key}3blend`">MinIP</label>

                <input
                  type="radio"
                  :id="`${key}4blend`"
                  value="AVG"
                  v-model="view.blendMode"
                />
                <label :for="`${key}4blend`">Average</label>
              </td>
            </tr>
          </table>

          <view-2d-mpr
            :volumes="volumes"
            :sliceIntersection="sliceIntersection"
            :views="viewData"
            :data-details="detailData"
            :onCreated="saveComponentRefGenerator(key)"
            :index="key"
            @rotate="onRotate"
            @thickness="onThickness"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dicomLoader from "@/library/lib/data/dicomLoader.js";
import axios from "axios";
import {
  View2dMPR,
  vtkInteractorStyleMPRCrosshairs,
  vtkInteractorStyleMPRWindowLevel,
} from "@/library";

import vtkVolume from "vtk.js/Sources/Rendering/Core/Volume";
import vtkVolumeMapper from "vtk.js/Sources/Rendering/Core/VolumeMapper";

import vtkMatrixBuilder from "vtk.js/Sources/Common/Core/MatrixBuilder";
import vtkCoordinate from "vtk.js/Sources/Rendering/Core/Coordinate";
// import vtkMath from "vtk.js/Sources/Common/Core/Math";
import vtkPlane from "vtk.js/Sources/Common/DataModel/Plane";

// eslint-disable-next-line no-unused-vars
import vtkXMLImageDataReader from "vtk.js/Sources/IO/XML/XMLImageDataReader";

import {
  BLEND_NONE,
  FRONT,
  LEFT,
  LEVEL_TOOL,
  TOP,
} from "@/library/VTKViewport/consts";

export default {
  name: "MPRDICOMVIEW",
  components: {
    "view-2d-mpr": View2dMPR,
  },
  props: {
    loadUrl: {
      type: Array,
    },
    //默认激活的工具，默认窗宽窗位
    activeTool: {
      type: String,
      default: LEVEL_TOOL,
    },
    //是否所有窗口同步调窗宽窗位
    syncWindowLevels: {
      type: Boolean,
      default: false,
    },
    //窗宽窗位调整比例
    windowLevelScale: {
      type: Number,
      default: 1,
    },
    //样本距离
    sampleDistance: {
      type: Number,
      default: 1,
    },
    ww: {
      type: Number,
      default: 350,
    },
    wl: {
      type: Number,
      default: 40,
    },
    viewData: {
      type: Object,
      default: () => ({
        [TOP]: {
          color: "#F8B42C",
          slicePlaneNormal: [0, 0, 1],
          sliceViewUp: [0, -1, 0],
          slicePlaneXRotation: 0,
          slicePlaneYRotation: 0,
          viewRotation: 0,
          sliceThickness: 0.1,
          blendMode: BLEND_NONE,
          curPage: 0,
          totalPage: 0,
          window: {
            width: 0,
            center: 0,
          },
          active: false,
        },
        [LEFT]: {
          color: "#A62CF8",
          slicePlaneNormal: [1, 0, 0],
          sliceViewUp: [0, 0, -1],
          slicePlaneXRotation: 0,
          slicePlaneYRotation: 0,
          viewRotation: 0,
          sliceThickness: 0.1,
          blendMode: BLEND_NONE,
          curPage: 0,
          totalPage: 0,
          window: {
            width: 0,
            center: 0,
          },
          active: false,
        },
        [FRONT]: {
          color: "#2C92F8",
          slicePlaneNormal: [0, -1, 0],
          sliceViewUp: [0, 0, -1],
          slicePlaneXRotation: 0,
          slicePlaneYRotation: 0,
          viewRotation: 0,
          sliceThickness: 0.1,
          blendMode: BLEND_NONE,
          curPage: 0,
          totalPage: 0,
          window: {
            width: 0,
            center: 0,
          },
          active: false,
        },
      }),
    },
    detailData: {
      type: Object,
      default: () => ({
        active: true,
        studyDate: "",
        studyTime: "",
        studyDescription: "",
        patientName: "",
        patientId: "",
        seriesNumber: "",
        seriesDescription: "",
        color: "",
      }),
    },
  },
  data() {
    return {
      volumes: [],
      components: [],
      focusedWidgetId: null,
      loading: true,
      sliceIntersection: [0, 0, 0],
      sliceIntersectionMax: [0, 0, 0],
      volumeBound: [],
      checkBoxTool: "",
    };
  },
  computed: {},
  created() {},
  watch: {
    window: {
      handler(newWindow) {
        this.updateColorWindow(newWindow.value);
      },
      deep: true,
    },
    level: {
      handler(newLevel) {
        this.updateColorLevel(newLevel.value);
      },
      deep: true,
    },
  },
  methods: {
    handleFileUpload() {
      console.log(this.$refs.files.files);
      this.loadData(this.$refs.files.files);
    },
    selectTool(tool) {
      this.activeTool = tool;
      // Switch the active interactor style.
      // TODO:
      switch (tool) {
        case "LEVEL":
          Object.entries(this.components).forEach(this.setLevelTool);
          break;
        case "SELECT":
          Object.entries(this.components).forEach(this.setCrosshairTool);
          break;
      }
    },
    checkBox(tool) {
      this.syncWindowLevels = !this.syncWindowLevels;
      if (this.syncWindowLevels) {
        this.checkBoxTool = "CHECKBOX";
      } else {
        this.checkBoxTool = "";
      }
    },
    setLevelTool([viewportIndex, component]) {
      const istyle = vtkInteractorStyleMPRWindowLevel.newInstance();
      istyle.setOnScroll(this.onScrolled);
      istyle.setOnLevelsChanged((levels) => {
        this.updateLevels({ ...levels, index: viewportIndex });
      });
      istyle.setLevelScale(this.windowLevelScale);
      setInteractor(component, istyle);
    },
    setCrosshairTool([viewportIndex, component]) {
      const istyle = vtkInteractorStyleMPRCrosshairs.newInstance();
      istyle.setOnScroll(this.onScrolled);
      istyle.setOnClickCallback(({ worldPos }) =>
        this.onCrosshairPointSelected({ worldPos, index: viewportIndex })
      );
      setInteractor(component, istyle);
    },
    onRotate(index, axis, angle) {
      // Match the source axis to the associated plane
      switch (index) {
        case "top":
          if (axis === "x") this.viewData.front.slicePlaneYRotation = angle;
          else if (axis === "y") this.viewData.left.slicePlaneYRotation = angle;
          break;
        case "left":
          if (axis === "x") this.top.slicePlaneXRotation = angle;
          else if (axis === "y") this.viewData.front.slicePlaneXRotation = angle;
          break;
        case "front":
          if (axis === "x") this.top.slicePlaneYRotation = angle;
          else if (axis === "y") this.viewData.left.slicePlaneXRotation = angle;
          break;
      }
    },
    onThickness(index, axis, thickness) {
      const shouldBeMIP = thickness > 1;
      let view;
      switch (index) {
        case "top":
          if (axis === "x") view = this.viewData.front;
          else if (axis === "y") view = this.viewData.left;
          break;
        case "left":
          if (axis === "x") view = this.top;
          else if (axis === "y") view = this.viewData.front;
          break;
        case "front":
          if (axis === "x") view = this.top;
          else if (axis === "y") view = this.viewData.left;
          break;
      }
      view.sliceThickness = thickness;
      // TODO: consts instead of magic strings
      if (shouldBeMIP && view.blendMode === "none") view.blendMode = "MIP";
      // else if(!shouldBeMIP) {
      //   view.blendMode = "none"
      // }
    },
    onScrolled() {
      let planes = [];
      Object.values(this.components).forEach((component) => {
        const camera = component.genericRenderWindow
          .getRenderer()
          .getActiveCamera();

        planes.push({
          position: camera.getFocalPoint(),
          normal: camera.getDirectionOfProjection(),
          // this[viewportIndex].slicePlaneNormal
        });
      });
      const newPoint = getPlaneIntersection(...planes);
      //计算总页码和当前页面
      this.caculatePage(newPoint);
      if (!Number.isNaN(newPoint)) {
        this.sliceIntersection = newPoint;
      }
    },
    //计算总页码和当前页面
    caculatePage(newPoint) {
      //left
      // eslint-disable-next-line no-unused-vars
      let leftTotalPage = Math.abs(Math.round(this.sliceIntersectionMax[0]));
      let leftCurPage = Math.ceil(newPoint[0] - this.volumeBound[0]);
      this.viewData.left.totalPage = leftTotalPage + 1;
      this.viewData.left.curPage = leftCurPage + 1;
      // console.log("leftTotalPage="+leftTotalPage+"  letCurPage="+leftCurPage);
      //front
      // eslint-disable-next-line no-unused-vars
      let frontTotalPage = Math.abs(Math.round(this.sliceIntersectionMax[1]));
      let frontCurPage =
        frontTotalPage - Math.ceil(newPoint[1] - this.volumeBound[2]);
      this.viewData.front.totalPage = frontTotalPage + 1;
      this.viewData.front.curPage = frontCurPage + 1;
      // console.log("frontTotalPage="+frontTotalPage+"  frontCurPage="+frontCurPage);
      //top
      let topTotalPage = Math.abs(Math.round(this.sliceIntersectionMax[2]));
      // eslint-disable-next-line no-unused-vars
      let topCurPage = Math.abs(Math.ceil(newPoint[2] - this.volumeBound[4]));
      this.viewData.top.totalPage = topTotalPage + 1;
      this.viewData.top.curPage = topCurPage + 1;
      // console.log("topTotalPage="+topTotalPage+"  topCurPage="+topCurPage);
    },
    onCrosshairPointSelected({ index, worldPos }) {
      Object.entries(this.components).forEach(([viewportIndex, component]) => {
        if (viewportIndex !== index) {
          // We are basically doing the same as getSlice but with the world coordinate
          // that we want to jump to instead of the camera focal point.
          // I would rather do the camera adjustment directly but I keep
          // doing it wrong and so this is good enough for now.
          // ~ swerik
          const renderWindow = component.genericRenderWindow.getRenderWindow();

          const istyle = renderWindow.getInteractor().getInteractorStyle();
          const sliceNormal = istyle.getSliceNormal();
          const transform = vtkMatrixBuilder
            .buildFromDegree()
            .identity()
            .rotateFromDirections(sliceNormal, [1, 0, 0]);

          const mutatedWorldPos = worldPos.slice();
          transform.apply(mutatedWorldPos);
          const slice = mutatedWorldPos[0];

          istyle.setSlice(slice);

          renderWindow.render();
        }

        const renderer = component.genericRenderWindow.getRenderer();
        const wPos = vtkCoordinate.newInstance();
        wPos.setCoordinateSystemToWorld();
        wPos.setValue(worldPos);

        // eslint-disable-next-line no-unused-vars
        const displayPosition = wPos.getComputedDisplayValue(renderer);
      });
    },

    updateLevels({ windowCenter, windowWidth, index }) {
      this.viewData[index].window.center = windowCenter;
      this.viewData[index].window.width = windowWidth;
      if (this.syncWindowLevels) {
        Object.entries(this.components)
          .filter(([key]) => key !== index)
          .forEach(([key, component]) => {
            this.viewData[key].window.center = windowCenter;
            this.viewData[key].window.width = windowWidth;
            component.genericRenderWindow
              .getInteractor()
              .getInteractorStyle()
              .setWindowLevel(windowWidth, windowCenter);
            component.genericRenderWindow.getRenderWindow().render();
          });
      }
    },

    saveComponentRefGenerator(viewportIndex) {
      return (component) => {
        this.components[viewportIndex] = component;

        // const { windowWidth, windowLevel } = getVOI(component.volumes[0]);
        // this.viewData[viewportIndex].window.width = windowWidth;
        // this.viewData[viewportIndex].window.center = windowLevel;
        const renderWindow = component.genericRenderWindow.getRenderWindow();
        renderWindow.getInteractor().getInteractorStyle().setVolumeMapper(null);

        // default to the level tool
        this.setLevelTool([viewportIndex, component]);

        renderWindow.render();
      };
    },

    rerenderAllViewports() {
      // Update all render windows, since the automatic re-render might not
      // happen if the viewport is not currently using the painting widget
      Object.values(this.components).forEach((component) => {
        component.genericRenderWindow.getRenderWindow().render();
      });
    },
    getDicom() {
      //path为dicom文件url路径
      return this.loadUrl.map((file_path, index) => {
        const path = file_path;
        return axios.get(path, { responseType: "blob" }).then((response) => {
          const jsFile = new File([response.data], `${index}.dcm`);
          return jsFile;
        });
      });
    },
    loadData(files) {
      this.loading = true;
      const volumeActor = vtkVolume.newInstance();
      const volumeMapper = vtkVolumeMapper.newInstance();
      //设置样本采距
      volumeMapper.setSampleDistance(this.sampleDistance);
      volumeActor.setMapper(volumeMapper);
      //loaderdicom--start
      const loader = dicomLoader.newInstance();
      let fetchFiles = this.getDicom();
      Promise.all(fetchFiles).then((path) => {
        loader.readFileSeries(path || files).then((data) => {
          volumeMapper.setInputData(data);
          // FIXME: custom range mapping
          //设置影像窗宽的范围
          const rgbTransferFunction = volumeActor
            .getProperty()
            .getRGBTransferFunction(0);
          rgbTransferFunction.setMappingRange(
            this.wl - this.ww / 2,
            this.wl + this.ww / 2
          );
          //为每个窗口设置窗宽窗位
          Object.values(this.viewData).forEach((view) => {
            view.window.center = this.wl;
            view.window.width = this.ww;
          });
          // TODO: find the volume center and set that as the slice intersection point.
          // TODO: Refactor the MPR slice to set the focal point instead of defaulting to volume center
          //获取中心位置
          this.sliceIntersection = getVolumeCenter(volumeMapper);
          //获取每个窗口的volume范围，为了计算总页码
          this.sliceIntersectionMax = getMaxVolume(volumeMapper);
          //获取每个窗口volume起始和终止值，为了计算当前页码
          this.volumeBound = getVolume(volumeMapper);
          ////计算总页码和当前页面
          this.caculatePage(this.sliceIntersection);
          this.volumes = [volumeActor];
          this.loading = false;
        });
      });

      //loaderdicom -- end
    },
  },
  mounted() {
    this.resizeFunction = () => {
      // not enough time between resize event and the right data coming through it seems.
      window.setTimeout(() => {
        this.onScrolled();
      }, 10);
    };
    // update intersection point when window resizes
    window.addEventListener("resize", this.resizeFunction);
    this.loadData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFunction);
  },
};

function setInteractor(component, istyle) {
  const renderWindow = component.genericRenderWindow.getRenderWindow();
  // We are assuming the old style is always extended from the MPRSlice style
  const oldStyle = renderWindow.getInteractor().getInteractorStyle();

  renderWindow.getInteractor().setInteractorStyle(istyle);
  // NOTE: react-vtk-viewport's code put this here, so we're copying it. Seems redundant?
  istyle.setInteractor(renderWindow.getInteractor());

  // Make sure to set the style to the interactor itself, because reasons...?!
  const inter = renderWindow.getInteractor();
  inter.setInteractorStyle(istyle);

  // Copy previous interactors styles into the new one.
  if (istyle.setSliceNormal && oldStyle.getSliceNormal()) {
    // console.log("setting slicenormal from old normal");
    istyle.setSliceNormal(oldStyle.getSliceNormal(), oldStyle.getViewUp());
  }
  if (istyle.setSlabThickness && oldStyle.getSlabThickness()) {
    istyle.setSlabThickness(oldStyle.getSlabThickness());
  }
  istyle.setVolumeMapper(component.volumes[0]);
}

//TODO: Unused, actually implement it!
// function generateStackScrollCallbackForIndex(windows, index) {
//   return ({ worldPos }) => {
//     windows.forEach((window, viewportIndex) => {
//       if (viewportIndex !== index) {
//         const renderWindow = window.genericRenderWindow.getRenderWindow();
//         const istyle = renderWindow.getInteractor.getInteractorStyle();
//         const sliceNormal = istyle.getSliceNormal();
//       }
//     });
//   };
// }

/**
 * Function Generator for updating the other views when clicking the crosshair tool
 */
// function generateCrosshairCallbackForIndex(windows, index) {
//   return ({ worldPos }) => {
//     console.log("getting crosshair coords", windows, index);
//     // Set camera focal point to world coordinate for linked views
//     Object.entries(windows).forEach(([viewportIndex, window]) => {
//       if (viewportIndex !== index) {
//         // We are basically doing the same as getSlice but with the world coordinate
//         // that we want to jump to instead of the camera focal point.
//         // I would rather do the camera adjustment directly but I keep
//         // doing it wrong and so this is good enough for now.
//         const renderWindow = window.genericRenderWindow.getRenderWindow();

//         const istyle = renderWindow.getInteractor().getInteractorStyle();
//         const sliceNormal = istyle.getSliceNormal();
//         const transform = vtkMatrixBuilder
//           .buildFromDegree()
//           .identity()
//           .rotateFromDirections(sliceNormal, [1, 0, 0]);

//         const mutatedWorldPos = worldPos.slice();
//         transform.apply(mutatedWorldPos);
//         const slice = mutatedWorldPos[0];

//         istyle.setSlice(slice);

//         renderWindow.render();
//       }

//       const renderer = window.genericRenderWindow.getRenderer();
//       const wPos = vtkCoordinate.newInstance();
//       wPos.setCoordinateSystemToWorld();
//       wPos.setValue(worldPos);

//       const displayPosition = wPos.getComputedDisplayValue(renderer);
//       const { svgWidgetManager } = window;
//       window.svgWidgets.crosshairsWidget.setPoint(
//         displayPosition[0],
//         displayPosition[1]
//       );
//       svgWidgetManager.render();
//     });
//   };
// }

/**
 * Planes are of type `{position:[x,y,z], normal:[x,y,z]}`
 * returns an [x,y,z] array, or NaN if they do not intersect.
 */
const getPlaneIntersection = (plane1, plane2, plane3) => {
  try {
    let line = vtkPlane.intersectWithPlane(
      plane1.position,
      plane1.normal,
      plane2.position,
      plane2.normal
    );
    if (line.intersection) {
      const { l0, l1 } = line;
      const intersectionLocation = vtkPlane.intersectWithLine(
        l0,
        l1,
        plane3.position,
        plane3.normal
      );
      if (intersectionLocation.intersection) {
        return intersectionLocation.x;
      }
    }
  } catch (err) {
    console.log("some issue calculating the plane intersection", err);
  }
  return NaN;
};
function getVolume(volumeMapper) {
  const bounds = volumeMapper.getBounds();
  return bounds;
}
function getMaxVolume(volumeMapper) {
  const bounds = volumeMapper.getBounds();
  return [bounds[1] - bounds[0], bounds[3] - bounds[2], bounds[5] - bounds[4]];
}
function getVolumeCenter(volumeMapper) {
  const bounds = volumeMapper.getBounds();
  return [
    (bounds[0] + bounds[1]) / 2.0,
    (bounds[2] + bounds[3]) / 2.0,
    (bounds[4] + bounds[5]) / 2.0,
  ];
}

const getVOI = (volume) => {
  // Note: This controls window/level

  // TODO: Make this work reactively with onModified...
  const rgbTransferFunction = volume.getProperty().getRGBTransferFunction(0);
  const range = rgbTransferFunction.getMappingRange();
  const windowWidth = range[0] + range[1];
  const windowCenter = range[0] + windowWidth / 2;

  return {
    windowCenter,
    windowWidth,
  };
};
</script>

<style scoped lang="scss">
.MPRDicomView {
  width: 100%;
  height: 100%;
  background: #182936;
  .MPR-loading {
    width: 100%;
    height: 100%;
  }
  .MPR-cont {
    width: 100%;
    height: 100%;
    .MPR-cont-header {
      height: 60px;
      display: flex;
      align-items: center;
    }
    .MPR-cont-cont {
      width: 100%;
      height: calc(100vh - 60px);
      display: flex;
      flex-direction: row;
      .col {
        flex: 1;
        height: 100%;
        .MPR-table {
          width: 100%;
          background: white;
          // border-radius: 6px;
          padding: 4px;
          border: 1px solid #182936;
        }
      }
    }
  }
}
</style>
<style scoped>
button {
  font-size: 14px;
  line-height: 20px;
}
button > img {
  vertical-align: middle;
  height: 20px;
}
button + button {
  margin-left: 8px;
}

button.active {
  background: #77b0df;
  border-color: #1370bd;
}

label + input {
  margin-left: 12px;
}

.row {
  /* max-height: 600px; */
  /* padding: 2px; */
  /* background: #000; */
}
.col {
  /* flex: 1;
  max-height: 400px; */
}
.col + .col {
  /* margin-left: 2px; */
}
</style>
